"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _ImmutableMerchandiseIdMap = _interopRequireDefault(require("self-service-api/constants/ImmutableMerchandiseIdMap"));

var _ProductTierOrders = _interopRequireDefault(require("self-service-api/constants/ProductTierOrders"));

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _SynonymousProducts = _interopRequireDefault(require("self-service-api/constants/SynonymousProducts"));

// This describes merch where you'll always have the free tier parcel
// even if you have a higher paid product
var FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS = [_MerchandiseIds.PRODUCT_MARKETING_FREE, _MerchandiseIds.PRODUCT_SALES_FREE, _MerchandiseIds.PRODUCT_SERVICE_FREE];

var hasSomeParcel = function hasSomeParcel(userParcels, productParcels) {
  return userParcels.some(function (userParcel) {
    var hasParcel = productParcels.some(function (productParcel) {
      var hasSameParcelName = productParcel.parcelName === userParcel.parcelName;
      var userParcelVersion = userParcel.parcelVersion ? userParcel.parcelVersion.version : null;
      var hasSameParcelVersion = productParcel.parcelVersion === userParcelVersion; // non-MAIN parcel version types don't qualify as product ownership

      var hasParcelVersionMain = userParcel.parcelVersion ? userParcel.parcelVersion.type === 'MAIN' : false;
      return hasSameParcelName && hasSameParcelVersion && hasParcelVersionMain;
    });
    return hasParcel;
  });
};

var _hasRightParcels = function _hasRightParcels(products, parcels, merchandiseId) {
  if (parcels.size === 0) return false;
  var product = products[merchandiseId];
  var additionalParcelsToCheck = _ImmutableMerchandiseIdMap.default[merchandiseId].parcels; // Parcel on the product may be redundant with additionalParcelsToCheck

  var parcelsForMerch = [];

  if (product) {
    parcelsForMerch.push({
      parcelName: product.parcelName,
      parcelVersion: product.parcelVersion
    });
  }

  if (additionalParcelsToCheck) {
    parcelsForMerch.push.apply(parcelsForMerch, (0, _toConsumableArray2.default)(additionalParcelsToCheck));
  } // Identity keeps around old parcels on a delay, so to accurately tell
  // what a portal owns, we need to make sure there isn't an expiresAt
  // prop on the parcel.


  var nonExpiringParcels = parcels.filter(function (parcel) {
    return !parcel.expiresAt;
  });
  return hasSomeParcel(nonExpiringParcels, parcelsForMerch);
};

var isProductOwnedAdapter = function isProductOwnedAdapter(productData, parcels, merchandiseId) {
  var merchandiseIdsTreatedAsOwned = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if (merchandiseIdsTreatedAsOwned.includes(merchandiseId)) {
    return true;
  }

  var products = productData.products;

  var hasRightParcels = _hasRightParcels(products, parcels, merchandiseId);

  if (FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS.indexOf(merchandiseId) === -1 || hasRightParcels === false) {
    return hasRightParcels;
  } // In the case of FREE_TIER_MERCHANDISE_WITH_PERSISTENT_PARCELS
  // we want to return false if any of the higher merchandise
  // return true for _hasRightParcels


  var tieredProductsGroup = _ProductTierOrders.default.filter(function (productTierOrder) {
    return productTierOrder.indexOf(merchandiseId) !== -1;
  })[0];

  var higherMerch = tieredProductsGroup.slice(1, tieredProductsGroup.length);
  return !higherMerch.some(function (higherMerchId) {
    var isSynonymousProduct = _SynonymousProducts.default.some(function (synonymousProducts) {
      return synonymousProducts.includes(merchandiseId) && synonymousProducts.includes(higherMerchId);
    });

    return _hasRightParcels(products, parcels, higherMerchId) && !isSynonymousProduct;
  });
};

var _default = isProductOwnedAdapter;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/adapters/isProductOwnedAdapter.js
// module id = 216
// module chunks = 5 6 7